import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const sections = [
  { id: "top", label: "HERO" },
  { id: "about", label: "ABOUT" },
  { id: "loadout", label: "LOADOUT" },
  { id: "contact", label: "CONTACT" },
];

export default function SectionNav() {
  const [active, setActive] = useState("top");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="fixed right-4 md:right-6 top-1/2 -translate-y-1/2 z-50 hidden md:flex flex-col items-end gap-3 pointer-events-none">
      {sections.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className="group flex items-center gap-2 pointer-events-auto"
        >
          <span className={`font-mono text-[8px] uppercase tracking-[0.2em] transition-all duration-300 ${
            active === id ? "text-[#F47B20] opacity-100" : "text-white/0 group-hover:text-white/40 opacity-0 group-hover:opacity-100"
          }`}>
            {label}
          </span>
          <div className="relative w-3 h-3 flex items-center justify-center">
            <motion.div
              className="absolute rounded-full"
              animate={{
                width: active === id ? 8 : 4,
                height: active === id ? 8 : 4,
                backgroundColor: active === id ? "#F47B20" : "rgba(255,255,255,0.15)",
              }}
              transition={{ duration: 0.3 }}
            />
            {active === id && (
              <motion.div
                layoutId="nav-ring"
                className="absolute w-3 h-3 rounded-full border border-[#F47B20]/40"
                transition={{ duration: 0.3 }}
              />
            )}
          </div>
        </a>
      ))}
    </div>
  );
}
